//Observe HTMLElements mutations, added to DOM, remove from DOM, attributes changes etc.
import { Observable } from 'rxjs';

export function mutationObservable(ref = document.body, config: MutationObserverInit = { childList: true, subtree: true }) {
  return new Observable<MutationRecord[]>(sub => {
    const observer = new MutationObserver((records) => sub.next(records));
    observer.observe(ref, config);
    return () => observer.disconnect();
  });
}

/**
 * @description determine if an array contains all items from another array.
 * @param {array} haystack the array to search.
 * @param {array} arr the array providing items to check for in the haystack.
 * @return {boolean} true|false if haystack contains at least one item from arr.
 */
export const hasAllElements = (haystack, arr) => {
  return arr.every(v => haystack.includes(v));
};


export const chunkArray = (arr, size) =>
  arr.length > size
    ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)]
    : [arr];
